import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { BlockFieldColumn } from 'web-ui-components/lib/global/layout';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidGlobalBehaviour } from '../../../utils/validation';

const required = value =>
  isValidGlobalBehaviour(value, 'alphaTwoSpaces') || !value ? undefined : 'Required';

const MiddleName = () => (
  <Content>
    {({
      personDetailsMiddleName = '',
      personDetailsMiddleNameHelpText = '',
      firstLastNameError = ''
    }) => (
      <Field name="middleName" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="middleName"
              hasError={touched && !!error}
              title={personDetailsMiddleName}
              description={personDetailsMiddleNameHelpText}
              validationMessage={firstLastNameError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="middleName" component="input" validate={required}>
                {({ input }) => (
                  <BlockFieldColumn column={6}>
                    <Input name="middleName" type="text" {...input} maxLength={12} />
                  </BlockFieldColumn>
                )}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

export default MiddleName;
